import { type ReactElement, type ReactNode } from "react";

import { cx } from "@emotion/css";
import { Group } from "@mantine/core";
import { Colors } from "@snapchat/snap-design-system";
import { CheckCircleIcon } from "@snapchat/snap-design-system-icons";

import styles from "./DropdownItem.module.css";
import { DropdownLabel, dropdownContainer, selectedContainer } from "./DropdownItem.styles";

interface DropdownItemProps {
    isSelected: boolean;
    label: string;
    detail?: ReactNode;
    highlightSelection?: boolean;
}

export const DropdownItem = ({
    label,
    detail,
    isSelected,
    highlightSelection = false,
}: DropdownItemProps): ReactElement => {
    const containerStyle = isSelected
        ? cx(dropdownContainer, selectedContainer, highlightSelection && styles.payoutSelected)
        : dropdownContainer;

    return (
        <Group w="100%" justify="space-between" align="center" wrap="nowrap" className={containerStyle}>
            <DropdownLabel>{label}</DropdownLabel>
            {detail && <DropdownLabel>{detail}</DropdownLabel>}
            {isSelected && !highlightSelection && <CheckCircleIcon size={24} fill={Colors.Green.V100} />}
        </Group>
    );
};
